import { Input } from "@mantine/core";
import Icon      from "_components/atoms/icon";
import useStyles from "./styles";

const component = ( { searchTerm, setSearchTerm, onFocus, onPressEnter, onPressEsc, placeholder = "Search", inputRef } ) => {
	const { classes } = useStyles ( undefined, { name: "searchTextField" } );

	const renderIcon = (
		<div style = { { paddingRight: "1rem", display: "flex", alignItems: "center", cursor: "pointer" } }>
			{searchTerm.length > 0 ? (
				<Icon
					className = { classes.crossIcon }
					name = "cross"
					onClick = { () => {
						setSearchTerm ( "" );
						inputRef?.current?.focus ();
					} }
					size = { 16 }
				/>
			) : (
				<Icon
					sameInBothTheme
					name = "iconSearch"
					size = { 18 }
				/>
			)}
		</div>
	);

	return (
		<Input
			ref = { inputRef }
			autoComplete = "off"
			classNames = { {
				input   : classes.root,
				wrapper : classes.searchBarContainer
			} }
			id = "input-popover-target"
			// onBlur    = { onBlur }
			onChange = { e => setSearchTerm ( e.target.value ) }
			onFocus = { onFocus }
			onKeyDown = { e => {
				if ( e.code === "Escape" ) {
					onPressEsc ();
				}
				if ( e.code === "Enter" ) {
					onPressEnter ();
				}
			} }
			placeholder = { placeholder }
			rightSection = { renderIcon }
			rightSectionWidth = { 70 }
			tabIndex = { "0" }
			value = { searchTerm }
		/>
	);
};

export default component;
